import React from 'react';
import './BillingInfoPanel.css';

const BillingInfoPanel = ({ billing }) => {
  if (!billing) return null;

  const {
    plan = 'N/A',
    paymentStatus = 'Unknown',
    stripeCustomerId = '-',
    stripeSubscriptionId = '-',
    tokenLimitPerMonth = 10000,
    tokensUsedThisMonth = 0,
    detokenizationsUsedThisMonth = 0,
    overageTokens = 0,
    estimatedOverageCostUsd = 0.0
  } = billing;

  const getStatusBadge = (st) => {
    const s = (st || '').toUpperCase();
    if (s === 'ACTIVE') return <span className="status-badge active">Active</span>;
    if (s === 'TRIAL') return <span className="status-badge draft">Trial Period</span>;
    if (s === 'PENDING') return <span className="status-badge suspended">Pending Confirmation</span>;
    if (s === 'PAST_DUE') return <span className="status-badge suspended">Past Due</span>;
    return <span className="status-badge archived">{s || 'Unknown'}</span>;
  };

  const limitNum = typeof tokenLimitPerMonth === 'number' ? tokenLimitPerMonth : 10000;
  const usedNum = typeof tokensUsedThisMonth === 'number' ? tokensUsedThisMonth : 0;
  const usagePercent = Math.min(100, Math.round((usedNum / Math.max(1, limitNum)) * 100));
  const isOverLimit = usedNum > limitNum;

  return (
    <section className="billing-panel" aria-label="Billing Information">
      <div className="panel-title-row">
        <div>
          <h3 className="billing-panel-title">Enterprise Subscription & Quotas</h3>
          <span className="billing-plan-label">{plan}</span>
        </div>
        {getStatusBadge(paymentStatus)}
      </div>

      {/* Metered Usage Progress */}
      <div className="metered-usage-block">
        <div className="usage-labels">
          <span className="usage-title">Monthly Quota Consumption</span>
          <span className="usage-numbers">
            <strong>{usedNum.toLocaleString()}</strong> / {limitNum.toLocaleString()} tokens ({usagePercent}%)
          </span>
        </div>
        <div className="usage-progress-bar-bg">
          <div
            className={`usage-progress-bar-fill ${isOverLimit ? 'over-quota' : (usagePercent > 80 ? 'near-quota' : '')}`}
            style={{ width: `${Math.min(100, usagePercent)}%` }}
          />
        </div>
        {isOverLimit && (
          <div className="overage-alert-badge">
            ⚠️ Overage: +{Number(overageTokens || (usedNum - limitNum)).toLocaleString()} metered tokens (Est. ${Number(estimatedOverageCostUsd || 0).toFixed(2)})
          </div>
        )}
      </div>

      <ul>
        <li>
          <span>Monthly Base Allowance</span>
          <strong>{limitNum.toLocaleString()} tokens</strong>
        </li>
        <li>
          <span>Detokenization Requests</span>
          <strong>{detokenizationsUsedThisMonth.toLocaleString()} calls</strong>
        </li>
        <li>
          <span>Stripe Customer ID</span>
          <code>{stripeCustomerId || 'Unlinked'}</code>
        </li>
        <li>
          <span>Active Subscription ID</span>
          <code>{stripeSubscriptionId || 'N/A'}</code>
        </li>
      </ul>
    </section>
  );
};

export default BillingInfoPanel;

